// Deployment overrides for the current environment.
// Managed by aldoo-deploy (Deployment tab). Direct edits OK; the deploy tool also rewrites this file.
const deployment = {
    APP_NAME: "Aldoo Snap",
    PLATFORM_API_URL: "https://api-snap.aldoo.com",
    INTERNAL_API_URL: "http://127.0.0.1:7055",
    API_URL: "https://snap.aldoo.com",
    PLATFORM_API_VERSION: "v1",
    STRIPE_API_KEY: "pk_test_your_stripe_key_here",
    APP_DOMAIN: "",
    GTM_ID: "",
    FACEBOOK_PIXEL: "",
    FACEBOOK_OPTIONS: false,
    TRACKING_GDPR: true,
    GOOGLE_ANALYTICS_ID: "",
    // Microsoft Ads UET tag (shared with translate.aldoo.com); goals Snap Purchase / Snap Subscription
    MICROSOFT_UET_ID: "343142718",
    MICROSOFT_UET_EVENTS: { purchase: "snap_purchase", subscribe: "snap_subscribe" },
    API_DIAGNOSTICS: false,
    ENCRYPTION_ENABLED: false,
    INFLIGHT_ENCRYPTION_KEY: ""
};

export default deployment;
